// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"1a4872bd","703":"974137ab"}[chunkId] + ".chunk.js";
};